import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import buildQuery, { OrderBy } from "odata-query";
import { body, request } from "services/request";

const resource = "api/catalogs";
const catalogsQuery = {
    orderBy: ["id desc"] as OrderBy<{}>,
    filter: { externalId: null },
};

const getCatalogs = () =>
    request(`${resource}/getSimple${buildQuery(catalogsQuery)}`, { method: "GET" }, { countInHeaders: true });

const getCatalogItems = ({ preparedFilter, externalId, ...params }: OdataFilters & { externalId: string }) => {
    const query = queryCollection(params, { filter: { ...preparedFilter, externalId } });
    return request(`${resource}/getItems${query}&withDeleted=true`, { method: "GET" }, { countInHeaders: true });
};

const catalogItemsList = ({ filter, ...params }: OdataFilters) =>
    request(`${resource}/getItems${containsQuery(params, { filter })}`, { method: "GET" });

const getCatalogInfo = (externalId: string) => {
    const query = buildQuery({ filter: { externalId } });
    return request(`${resource}/getCatalogs${query}`, { method: "GET" }).then((data) =>
        data && data[0] ? data[0] : {},
    );
};

const index = () => getCatalogs();

const applyItem = (data: {}) => request(`${resource}/applyItem`, body(data));

const deleteItem = (data: {}) => request(`${resource}/deleteItem`, body(data));

const applyItemEntityOptions = (data: {}) => request(`${resource}/applyItemEntityOptions`, body(data));

export { index, applyItem, deleteItem, applyItemEntityOptions, getCatalogItems, getCatalogInfo, catalogItemsList };
